import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    cursor: 'pointer',
    padding: 4
  }
}))

export default useStyles
